import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { SelectOptions } from '@portal/models/module';

export interface AdvancedRadioProps {
  row?: boolean;
  label?: string | string[];
  value?: number | string | boolean;
  onChange: (newValue: string) => void;
  name: string;
  options: SelectOptions[] | undefined;
}

const AdvancedRadio = ({
  row,
  value,
  label,
  onChange,
  name,
  options,
}: AdvancedRadioProps) => {
  return (
    <div className="advanced-radio">
      <FormControl component="fieldset">
        {label ? (
          <div className="advanced-radio__label">
            <FormLabel component="legend">{label}</FormLabel>
          </div>
        ) : null}
        <RadioGroup
          row={row}
          aria-label={name}
          name={name}
          value={value}
          onChange={(__event, value) => onChange(value)}
        >
          {options
            ? options.map((item, itemIndex) => (
                <FormControlLabel
                  key={itemIndex.toString()}
                  label={item.name}
                  value={item.value}
                  control={<Radio color="primary" />}
                />
              ))
            : null}
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default AdvancedRadio;
